export default class Splicing {
  constructor(api) {
    this.api = api;
  }

  getObjectFiberConnections(objectEndpoint, objectUUID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/" + objectEndpoint + "/" + objectUUID + "/fiber-connections")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getPhysicalConnections(obj, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/networks/splicing/physicalconnections", obj)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createRack(obj, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/racks", obj)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editRack(obj, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/racks", obj)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  removeRack(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete(`v1/racks/${uuid}`)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createDrawer(obj, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/drawers", obj)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateDrawer(obj, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/drawers", obj)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  removeDrawer(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete(`v1/drawers/${uuid}`)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getSplicingConnections(objectEndpoint, objectUUID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/" + objectEndpoint + "/" + objectUUID + "/all-circuit-connections"
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateSplicingConnections(
    objectEndpoint,
    objectUUID,
    updatedConnections,
    onSuccess,
    onError
  ) {
    return this.api.http_fibercloud
      .put(
        "v1/" + objectEndpoint + "/" + objectUUID + "/all-circuit-connections",
        updatedConnections
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  saveSplicingConnections(
    objectEndpoint,
    objectUUID,
    updatedConnections,
    onSuccess,
    onError
  ) {
    return this.api.http_fibercloud
      .put(
        "v1/" + objectEndpoint + "/" + objectUUID + "/all-circuit-connections",
        updatedConnections
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getFiberCircuitByUuid(uuid, onSuccess, onError) {
    const workspaceUUID = sessionStorage.getItem("workspace_uuid");
    return this.api.http_fibercloud
      .get(
        "v1/fibers/" + uuid + "/circuits" + "?workspace_uuid=" + workspaceUUID
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getClosureCassettes(filter, onSuccess, onError) {
    let filters = filter ? '?' + filter : '';
    return this.api.http_fibercloud
      .get(
        "v1/cassettes" + filters
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editFibers(fibersData, onSuccess, onError) {
    return this.api.http_fibercloud
      .put(
        "v1/fibers", fibersData
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createCassette(cassetteData, onSuccess, onError) {
    return this.api.http_fibercloud
      .post(
        "v1/cassettes", cassetteData
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editCassette(cassetteData, onSuccess, onError) {
    return this.api.http_fibercloud
      .put(
        "v1/cassettes", cassetteData
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteCassette(cassetteUuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete(
        "v1/cassettes/" + cassetteUuid
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/splicing.js